import { enqueueModal } from './store'
import type { AlertModalOptions, ConfirmModalOptions, PromptModalOptions } from './types'

export function confirmModal(options: ConfirmModalOptions): Promise<boolean> {
  return new Promise((resolve) => {
    enqueueModal({ kind: 'confirm', ...options, resolve })
  })
}

export function promptModal(options: PromptModalOptions): Promise<string | null> {
  return new Promise((resolve) => {
    enqueueModal({ kind: 'prompt', ...options, resolve })
  })
}

export function alertModal(options: AlertModalOptions): Promise<void> {
  return new Promise((resolve) => {
    enqueueModal({ kind: 'alert', ...options, resolve })
  })
}
